/**
 * File: /home/cordova03/projects/educore_3.5/src/app/utilities/utilitiesModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Wednesday, December 5th 2018, 3:09:34 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Thu Dec 20 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import uiRouter from 'angular-ui-router';
import template from './views/curriculumConsole.html';
import controller from './controllers/curriculumConsoleController';
import _ from "underscore"
var module = angular.module('CurriculumConsoleModule', [
    uiRouter
    //import modules
]).controller('curriculumConsole', controller);




// WEBPACK FOOTER //
// ./src/app/initialSettings/curriculumConsole/curriculumConsoleModule.js